<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-hourglass`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M40 3a2 2 0 110 4h-1v3.83c.007 3.9-1.38 6.92-4.163 8.821-1.555 1.063-3.501 2.19-5.842 3.388 2.855 1.35 4.999 2.513 6.449 3.504 2.536 1.733 3.675 4.773 3.556 8.818V41h1a2 2 0 110 4H8a2 2 0 110-4h2v-5.636c-.007-3.9 1.38-6.92 4.163-8.82 1.555-1.064 3.502-2.192 5.843-3.388-2.856-1.35-5-2.514-6.45-3.505C11.02 17.918 9.881 14.88 10 10.834V7H8a2 2 0 110-4h32zM24.525 25.392c-3.455 1.636-6.16 3.124-8.105 4.454-1.617 1.104-2.425 2.863-2.42 5.515L13.992 41H18v-9a1 1 0 011-1h2a1 1 0 011 1v9h5v-5a1 1 0 011-1h2a1 1 0 011 1v5h4.001v-5.698c.084-2.867-.567-4.605-1.814-5.456-1.655-1.131-4.555-2.627-8.662-4.454zM35 7H13.999v3.892c-.084 2.867.568 4.605 1.814 5.457 1.655 1.13 4.556 2.626 8.662 4.454 3.455-1.636 6.16-3.125 8.105-4.454 1.617-1.105 2.425-2.864 2.42-5.515V7z"/></svg>
</template>
<script>

export default {
  name: 'IconHourglass',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
